<style>

.gallery .home-image-icon-container {
    border: 10px solid black;
}

.gallery .home-image-icon {
    width: 160%;
    margin-top: -25%;
    margin-left: -30%;
    transition: 1.5s all;
    max-width: none;
}

.gallery .home-image-icon:hover {
    width: 170%;
    margin-top: -30%;
    margin-left: -35%;
}

</style>

<template>

<div class="bg-black gallery">
    <div class=" mx-auto mt-24 xl:mt-40 px-10">
        <!-- <div class="uppercase text-center mb-6">Gallery</div> -->
        <div class="flex flex-wrap justify-center mb-24">
            <div v-for='(image, i) in images' v-bind:key='image' class="home-image-icon-container w-1/2 lg:w-1/4 h-32 xl:h-56 overflow-hidden cursor-pointer" @click='toggleModal(i)'>
                <img class="home-image-icon  h-auto" :src="image+'thumb.jpg'" />
            </div>
        </div>
    </div>

    <ModalGallery :images='images' :isOpen='modalIsOpen' :navigateTo='slideIndex' @on-close='toggleModal' />
</div>

</template>

<script>

import ModalGallery from '@/components/ModalGallery.vue'

export default {
    name: 'gallery',

    data() {
        return {
            modalIsOpen: false,
            slideIndex: 0,
            images: [
                '/images/new-photos/exterior',
                // '/images/home-gallery/exterior',
                '/images/new-photos/lobby_055',
                '/images/new-photos/lobby_058',
                '/images/new-photos/lobby_059',
                '/images/new-photos/lobby_062',
                '/images/new-photos/lobby_063',
                // '/images/home-gallery/home1',
                // '/images/home-gallery/home2',
                // '/images/home-gallery/home3',
                // '/images/light-finish/light1',
                // '/images/light-finish/light2',
                // '/images/light-finish/light3',
                // '/images/dark-finish/dark1',
                // '/images/dark-finish/dark2',
                // '/images/dark-finish/dark3'

                '/images/new-photos/6fl_030',
                '/images/new-photos/6fl_034',
                '/images/new-photos/6fl_036',
                '/images/new-photos/6fl_042',
                '/images/new-photos/16fl_002',
                '/images/new-photos/16fl_004',
                '/images/new-photos/16fl_005',
                '/images/new-photos/16fl_016',
                '/images/new-photos/16fl_017',
                '/images/new-photos/16fl_018',
//
                '/images/new-photos/7th_fl_terrace',
                '/images/new-photos/10th_fl_terrace',
                '/images/new-photos/2nd_fl_terrace',
                '/images/new-photos/17th_fl_terrace',
                '/images/new-photos/conf_room',
                '/images/new-photos/conf_room_table'
            ]
        }
    },

    components: {
        ModalGallery
    },

    methods: {
        toggleModal(i) {
            this.slideIndex = i
            this.modalIsOpen = !this.modalIsOpen
        }
    }
}

</script>
